// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { isMobileScreen, isTabletScreen } from "@stoneage/XDL/Utilities";
import { Draft } from "immer";

type CommonDataState = Readonly<{
    isBomView?: boolean;
    isMobileScreen?: boolean;
    isTabletScreen?: boolean;
    headerHeight?: number;
    [key: string]: any;
}>;

export const initialCommonState: CommonDataState = {
    isBomView: false,
    isMobileScreen: isMobileScreen(),
    headerHeight: 0,
};

const reducer = {
    "xCommon/update": (draft: Draft<CommonDataState>, action: { data: CommonDataState }) => {
        const { key, value } = action.data;
        draft[key] = value as never;
    },
};

const xCommon = createTypedReducerWithImmer(initialCommonState, reducer);

(reducers as any).xCommon = xCommon;

export type xCommonState = {
    xCommon: CommonDataState;
};

type xCommonReducers = {
    [key: string]: typeof xCommon;
};

export type xCommonActions = Parameters<xCommonReducers[keyof xCommonReducers]>[1] | AnyAction;
